/** Fulltextové hledání v katalogu. */

import { Search, X } from 'lucide-react';

export default function SearchInput({
  value,
  onChange,
  placeholder = 'Hledat materiál…',
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}) {
  return (
    <div className="relative">
      <Search
        className="pointer-events-none absolute left-3.5 top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-ink-soft"
        strokeWidth={2}
      />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label="Hledat v katalogu"
        className="h-12 w-full rounded-xl border border-line bg-card pl-11 pr-11 text-base outline-none transition placeholder:text-ink-soft/70 focus:border-board focus:ring-2 focus:ring-board/20"
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="Vymazat hledání"
          className="absolute right-2 top-1/2 grid h-9 w-9 -translate-y-1/2 place-items-center rounded-lg text-ink-soft transition hover:bg-paper2"
        >
          <X className="h-[18px] w-[18px]" strokeWidth={2} />
        </button>
      )}
    </div>
  );
}
